<template>
  <el-dialog title="批量操作" :visible.sync="dialogVisible" @close="dialogFormVisible" :close-on-click-modal="false" :close-on-press-escape="false">
    <el-form size="small" :model="formData" :rules="formRules" ref="formData">

      <!--名称-->
      <el-form-item label="选中数量" :label-width="formLabelWidth">
        <p class="red f20">{{ formData.ids.length || '暂无选中记录' }}</p>
      </el-form-item>

      <el-form-item label="所属分类：" :label-width="formLabelWidth">
        <el-select v-model="formData.category_id">
          <template v-for="cat in category">
            <el-option :value="cat.category_id" :key="cat.category_id" :label="cat.name"></el-option>
            <template v-if="cat.child !== undefined">
              <template v-for="two in cat.child">
                <el-option :value="two.category_id" :key="two.category_id" :label="two.name" style="padding-left: 30px;"></el-option>
                <template v-if="two.child !== undefined">
                  <template v-for="three in two.child">
                    <el-option :value="three.category_id" :key="three.category_id" :label="three.name" style="padding-left: 60px;"></el-option>
                  </template>
                </template>
              </template>
            </template>
          </template>
        </el-select>
      </el-form-item>
      <el-form-item label="商品标签：" v-auth="'/product/label/index'" :label-width="formLabelWidth">
        <el-select v-model="formData.label_id" multiple filterable placeholder="请选择">
          <el-option
            v-for="item in label"
            :key="item.id"
            :label="item.name"
            :value="item.id">
          </el-option>
        </el-select>
      </el-form-item>

      <el-form-item label="产品状态" prop="product_status" :label-width="formLabelWidth">
        <el-radio-group v-model="formData.product_status">
          <el-radio :label="10">上架</el-radio>
          <el-radio :label="20">下架</el-radio>
          <el-radio :label="30">草稿</el-radio>
        </el-radio-group>
      </el-form-item>

      <el-form-item label="是否新品" prop="is_new" :label-width="formLabelWidth">
        <el-radio-group v-model="formData.is_new">
          <el-radio :label="1">是</el-radio>
          <el-radio :label="0">否</el-radio>
        </el-radio-group>
      </el-form-item>

      <el-form-item label="是否热卖" prop="is_hot" :label-width="formLabelWidth">
        <el-radio-group v-model="formData.is_hot">
          <el-radio :label="1">是</el-radio>
          <el-radio :label="0">否</el-radio>
        </el-radio-group>
      </el-form-item>

      <el-form-item label="是否推荐" prop="is_recommend" :label-width="formLabelWidth">
        <el-radio-group v-model="formData.is_recommend">
          <el-radio :label="1">是</el-radio>
          <el-radio :label="0">否</el-radio>
        </el-radio-group>
      </el-form-item>

      <el-form-item label="是否隐藏" prop="is_show" :label-width="formLabelWidth">
        <el-radio-group v-model="formData.is_show">
          <el-radio :label="1">是</el-radio>
          <el-radio :label="0">否</el-radio>
        </el-radio-group>
      </el-form-item>

      <el-form-item label="是否农产品" prop="is_agri" :label-width="formLabelWidth">
        <el-radio-group v-model="formData.is_agri">
          <el-radio :label="1">是</el-radio>
          <el-radio :label="0">否</el-radio>
        </el-radio-group>
      </el-form-item>

      <el-form-item label="初始销量" prop="sales_initial" :label-width="formLabelWidth">
        <el-input v-model="formData.sales_initial" placeholder="请输入" type="number" style="width:120px"></el-input>
      </el-form-item>

      <div class="common-form mt50" v-auth="'/plus/agent/index'">分销设置</div>

        <el-form-item label="是否开启单独分销："  v-auth="'/plus/agent/index'" :label-width="formLabelWidth">
          <el-radio-group v-model="formData.is_ind_agent">
            <el-radio :label="1">开启</el-radio>
            <el-radio :label="0">关闭</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="分销类型："  v-auth="'/plus/agent/index'" v-if="formData.is_ind_agent ==1" :label-width="formLabelWidth">
          <el-radio-group v-model="formData.commission_type">
            <el-radio :label="0">统一</el-radio>
            <el-radio :label="1">按等级</el-radio>
          </el-radio-group>
        </el-form-item>
        <template v-if="formData.is_ind_agent === 1 && formData.commission_type === 0"  v-auth="'/plus/agent/index'" >
          <el-form-item label="分销佣金类型：" :label-width="formLabelWidth">
            <el-radio-group v-model="formData.agent_money_type" @change="changeMoneyType">
              <el-radio :label="10">百分比</el-radio>
              <el-radio :label="20">固定金额</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="单独分销设置：" :label-width="formLabelWidth">
            <el-input type="number" min="0" v-model="formData.first_money" class="max-w300">
              <template slot="prepend">
                一级佣金：
              </template>
              <template slot="append">
                {{ unit }}
              </template>
            </el-input>

          </el-form-item>
          <el-form-item v-if="basicSetting.level >= 2" :label-width="formLabelWidth">
            <el-input type="number" min="0" v-model="formData.second_money" class="max-w300">
              <template slot="prepend">
                二级佣金：
              </template>
              <template slot="append">
                {{ unit }}
              </template>
            </el-input>

          </el-form-item>
          <el-form-item v-if="basicSetting.level >= 3" :label-width="formLabelWidth">
            <el-input type="number" min="0" v-model="formData.third_money" class="max-w300">
              <template slot="prepend">
                三级佣金：
              </template>
              <template slot="append">
                {{ unit }}
              </template>
            </el-input>

          </el-form-item>
        </template>
        <template v-if="formData.is_ind_agent === 1 && formData.commission_type === 1"  v-auth="'/plus/agent/index'">
          <el-form-item label="分销佣金类型：" :label-width="formLabelWidth">
            <el-radio-group v-model="formData.agent_money_type" @change="changeMoneyType">
              <el-radio :label="10">百分比</el-radio>
              <el-radio :label="20">固定金额</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="单独分销设置：" :label-width="formLabelWidth">
            <div style="max-width: 800px;">
              <el-table :data="gradeList" border style="width: 100%">
                <el-table-column prop="name" label="会员等级">
                </el-table-column>
                <el-table-column prop="name" label="佣金设置" width="650px">
                  <template v-slot="scope">
                      <el-input type="number" min="0" v-model="scope.row.first_money" class="max-w300">
                        <template slot="prepend">
                          一级佣金：
                        </template>
                        <template slot="append">
                          {{ unit }}
                        </template>
                      </el-input>

                      <el-form-item v-if="basicSetting.level >= 2">
                        <el-input type="number" min="0" v-model="scope.row.second_money" class="max-w300">
                          <template slot="prepend">
                            二级佣金：
                          </template>
                          <template slot="append">
                            {{ unit }}
                          </template>
                        </el-input>

                      </el-form-item>
                      <el-form-item v-if="basicSetting.level >= 3">
                        <el-input type="number" min="0" v-model="scope.row.third_money" class="max-w300">
                          <template slot="prepend">
                            三级佣金：
                          </template>
                          <template slot="append">
                            {{ unit }}
                          </template>
                        </el-input>
                      </el-form-item>
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </el-form-item>
        </template>

        <div class="common-form mt50"  v-auth="'/plus/agent/discount/index'">团队平级奖设置</div>
          <el-form-item label="是否开启：" v-auth="'/plus/agent/discount/index'"  :label-width="formLabelWidth">
            <el-radio-group v-model="formData.is_alone_enable_grade_equity">
              <el-radio :label="1">开启</el-radio>
              <el-radio :label="0">关闭</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="奖励类型" v-if="formData.is_alone_enable_grade_equity==1" :label-width="formLabelWidth">
            <el-radio-group v-model="formData.alone_enable_grade_type" @change="changeGradeLevelType">
              <el-radio :label="10">按百分比</el-radio>
              <el-radio :label="20">固定金额</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="" v-if="formData.is_alone_enable_grade_equity==1 " :label-width="formLabelWidth" v-auth="'/plus/agent/discount/index'">
            <div class="max-w650">
              <el-table :data="gradeRangeList" border size="mini" style="width: 100%">
                <el-table-column prop="name" label="会员等级">
                </el-table-column>
                <el-table-column prop="name" label="团队奖励">
                  <template v-slot="scope">
                    <div class="d-s-c">
                      <el-input v-model="scope.row.grade_award" type="number" placeholder="请输入数字额">
                        <template slot="append">{{grade_level_unit}}</template>
                      </el-input>
                    </div>
                  </template>
                </el-table-column>
                <el-table-column prop="name" label="平级奖励">
                  <template v-slot="scope">
                    <div class="d-s-c">
                      <el-input v-model="scope.row.same_award" type="number" placeholder="请输入数字额">
                        <template slot="append">{{grade_level_unit}}</template>
                      </el-input>
                    </div>
                  </template>
                </el-table-column>

              </el-table>
            </div>
          </el-form-item>

      <!-- <el-form-item label="一口价" prop="product_price" :label-width="formLabelWidth">
        <el-input v-model="formData.product_price" placeholder="请输入" type="number" style="width:120px"></el-input>
      </el-form-item> -->

      <!-- <el-form-item label="总库存" prop="product_stock" :label-width="formLabelWidth">
        <el-input v-model="formData.product_stock" placeholder="请输入" type="number" style="width:120px"></el-input>
      </el-form-item> -->

      <el-form-item label="排序" prop="product_sort" :label-width="formLabelWidth">
        <el-input v-model="formData.product_sort" placeholder="请输入" type="number" style="width:120px"></el-input>
        <span class="gray9">数字越小越靠前</span>
      </el-form-item>

      <el-form-item label="删除" prop="is_delete" :label-width="formLabelWidth">
        <el-radio-group v-model="formData.is_delete">
          <el-radio label="">否</el-radio>
          <el-radio :label="1">是</el-radio>
        </el-radio-group>
      </el-form-item>

    </el-form>
    <!--操作按钮-->
    <div slot="footer" class="dialog-footer">
      <el-button @click="dialogFormVisible">取 消</el-button>
      <el-button type="primary" @click="onSubmit()" :disabled="loading || ids.length==0">确 定</el-button>
    </div>
  </el-dialog>
</template>

<script>
import PorductApi from '@/api/product.js';
export default {
  data() {
    return {
      /*是否加载中*/
      loading: false,
      show_profit_member:0,
      /*form表单数据对象*/
      formData: {
        ids: [],
        category_id: '',
        product_status: '',
        is_new: '',
        is_hot: '',
        is_recommend: '',
        sales_initial: '',
        product_price: '',
        product_stock: '',
        product_sort: '',
        is_delete: '',

        /*是否开启单独分销,默认0为关闭，1为开启*/
        is_ind_agent: -1,
        /*分销类型 0 统一 1 按等级*/
        commission_type:0,
        /*分销佣金类型,默认10为百分比，20为固定金额*/
        agent_money_type: 10,
        /*一级佣金*/
        first_money:0,
        /*二级佣金*/
        second_money:0,
        /*三级佣金*/
        third_money:0,


        /*代理极差设置,默认0为关闭，1为开启*/
        is_alone_enable_grade_equity:-1,
        // 返佣类型 10 百分比，20 固定金额
        alone_enable_grade_type:10,
        label_id:''
      },
      label:[],
      basicSetting: {},
        /*会员等级*/
      gradeList: [],
      gradeRangeList: [],
      grade_level_unit:"%",
      point_unit: '%',
      unit: '%',
      /*验证规则*/
      formRules: {},
      /*左边长度*/
      formLabelWidth: '120px',
      /*是否显示*/
      dialogVisible: false,
    };
  },
  props: ['is_open', 'ids', 'category'],
  created() {
    this.dialogVisible = this.is_open;
    this.formData.ids = this.ids;
    /*获取基础数据*/
    this.getBaseData();
  },
  methods: {
    /*换算单位*/
    changeMoneyType: function(val) {
          if (val == '10') {
            this.unit = '%';
            this.point_unit = '%';
          } else {
            this.unit = '元';
            this.point_unit = '积分';
          }
      },
    /*换算单位*/
    changeGradeLevelType: function(val) {
          if (val == '10') {
            this.grade_level_unit = '%';
          } else {
            this.grade_level_unit = '元';
          }
      },
    /*转JSON字符串*/
    convertMoneyJson(list){
      let obj={};
      let obj1={};
      let obj2={};
      let obj11={};
      let obj21={};
      let obj31={};
      let obj3={};
      let obj4={};
      let obj5={};
      let arr ={};
      list.forEach(item=>{
        obj[item.grade_id]=item.first_money;
        obj1[item.grade_id]=item.second_money;
        obj2[item.grade_id]=item.third_money;
        obj11[item.grade_id]=item.first_money_member;
        obj21[item.grade_id]=item.second_money_member;
        obj31[item.grade_id]=item.third_money_member;
        obj3[item.grade_id]=item.first_point;
        obj4[item.grade_id]=item.second_point;
        obj5[item.grade_id]=item.third_point;
      });
      arr['first_money'] = obj;
      arr['second_money'] = obj1;
      arr['third_money'] = obj2;
      arr['first_money_member'] = obj11;
      arr['second_money_member'] = obj21;
      arr['third_money_member'] = obj31;
      arr['first_point'] = obj3;
      arr['second_point'] = obj4;
      arr['third_point'] = obj5;
      return JSON.stringify(arr);
    },
    /*转JSON字符串*/
    convertEnableJson(list){
      let obj={};
      list.forEach(item=>{
        console.log(item.grade_id)
        if(item.grade_id){
          obj[item.grade_id] = {'grade_award':item.grade_award ? item.grade_award: 0,'same_award':item.same_award ? item.same_award: 0};
        }
      });
      return JSON.stringify(obj);
    },
    /*获取基础数据*/
    getBaseData: function() {
      let self = this;
      PorductApi.getBaseData({}, true)
        .then(res => {
          self.loading = false;
          Object.assign(self.formData, res.data);
          self.gradeList = res.data.gradeList;
          self.basicSetting = res.data.basicSetting;
          self.gradeRangeList = res.data.gradeRangeList;
          self.label = res.data.label;
          self.gradeList.forEach(item=>{
            self.$set(item, 'first_money', 0)
            self.$set(item, 'second_money', 0)
            self.$set(item, 'third_money',0)
            self.$set(item, 'first_money_member', 0)
            self.$set(item, 'second_money_member', 0)
            self.$set(item, 'third_money_member',0)
            self.$set(item, 'first_point', 0)
            self.$set(item, 'second_point', 0)
            self.$set(item, 'third_point',0)
            self.$set(item, 'push',0),
            self.$set(item, 'buy_total_set',0)
            self.$set(item, 'pick_total_set',0)
          });
        })
        .catch(error => {
          self.loading = false;
        });
    },
    /*添加*/
    onSubmit() {
      let self = this;
      let params = this.formData;
      if (params.ids.length<=0){
        self.$message({
          message: '暂无选中记录',
          type: 'warning'
        });
        return;
      }
      params.alone_money_equity=self.convertMoneyJson(self.gradeList);
      params.alone_enable_grade_equity=self.convertEnableJson(self.gradeRangeList);
      delete params.catgory;
      delete params.delivery;
      delete params.gradeList;
      delete params.basicSetting;
      delete params.label;
      delete params.gradeRangeList;
      delete params.specData;
      delete params.isSpecLocked;
      delete params.isTypeLocked;
      self.$refs.formData.validate(valid => {
        if (valid) {
          self.loading = true;
          PorductApi.batch(params, true)
            .then(res => {
              if (res.code == 1) {
                self.$message({
                  message: res.msg,
                  type: 'success'
                });
                self.dialogFormVisible(true);
                self.loading = false;
              }
            })
            .catch(error => {
              self.loading = false;
            });
        }
      });
    },

    /*关闭弹窗*/
    dialogFormVisible(e) {
      if (e) {
        this.$emit('closeDialog', {
          type: 'success',
          openDialog: false
        });
      } else {
        this.$emit('closeDialog', {
          type: 'error',
          openDialog: false
        });
      }
    },
  }
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/views/product/product/batch.vue